export type Locale = 'en' | 'es';

export const LOCALES: readonly Locale[] = ['en', 'es'];

const EN = {
  'menu.timeline': 'The Timeline',
  'menu.characterInventory': 'Character / Inventory',
  'menu.leaderboards': 'Leaderboards',
  'menu.challenges': 'Challenges',
  'menu.online': 'Online Co-op',
  'menu.begin': 'Begin Run',
  'menu.continue': 'Continue Run',
  'menu.settings': 'Settings',
  'menu.account': 'Account',
  'menu.tagline': 'Stand still to fire. Move to survive.',
  'menu.fall': 'Fall through time.',
  'settings.language': 'Language',
  'hub.title': 'The Timeline',
  'hub.characters': 'Characters',
  'hub.skills': 'Skill Tree',
  'hub.inventory': 'Inventory',
  'hub.unlocks': 'Unlocks',
  'hub.pets': 'Pets',
  'hub.observatory': 'Observatory',
  'hub.anchors': 'Temporal Anchors',
  'hub.achievements': 'Achievements',
  'common.back': 'Back',
} as const;

type Key = keyof typeof EN;

const ES: Record<Key, string> = {
  'menu.timeline': 'La Línea Temporal',
  'menu.characterInventory': 'Personaje / Inventario',
  'menu.leaderboards': 'Clasificaciones',
  'menu.challenges': 'Desafíos',
  'menu.online': 'Cooperativo en línea',
  'menu.begin': 'Comenzar partida',
  'menu.continue': 'Continuar partida',
  'menu.settings': 'Ajustes',
  'menu.account': 'Cuenta',
  'menu.tagline': 'Quédate quieto para disparar. Muévete para sobrevivir.',
  'menu.fall': 'Cae a través del tiempo.',
  'settings.language': 'Idioma',
  'hub.title': 'La Línea Temporal',
  'hub.characters': 'Personajes',
  'hub.skills': 'Árbol de habilidades',
  'hub.inventory': 'Inventario',
  'hub.unlocks': 'Desbloqueos',
  'hub.pets': 'Compañeros',
  'hub.observatory': 'Observatorio',
  'hub.anchors': 'Anclas temporales',
  'hub.achievements': 'Logros',
  'common.back': 'Volver',
};

export function tr(locale: Locale, key: Key): string {
  return locale === 'es' ? ES[key] : EN[key];
}
